
export default {
  methods: {
    goToPage(page) {
      this.$store.commit("filters", { ...this.$store.getters.filters, page });
      this.$router.push(this.$hyperUtility.urlElasticCreator('page',page,1));
    },
  },
};
